// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './services/Webservice';
import shareService from './services/ShareService'
import 'vuejs-noty/dist/vuejs-noty.css'
import VueNoty from 'vuejs-noty'
import VeeValidate from 'vee-validate'


Vue.$api = api
Vue.$shareService = shareService


Vue.config.productionTip = false
Vue.use(VueNoty, {
    timeout: 1500
})

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})

Object.defineProperty(Vue.prototype, '$api', {
    get () {
      return api
    }
  })

Object.defineProperty(Vue.prototype, '$shareService', {
    get() {
        return shareService
    }
})

Vue.use(VeeValidate, {
    classes: true
})

Vue.use(require('vue-moment'))

Vue.filter('titleCase', function(value) {
    if (!value) {
        return ''
    } else {
        var str = ''
        var arr = value.split('_')
        for (var i = 0; i < arr.length; i++) {
            if (i == 0) {
                str = arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
            } else {
                str = ' ' + arr[i].charAt(0).toUpperCase() + arr[i].substring(1).toLowerCase();
            }
        }
        return str
    }
})



// WEBPACK FOOTER //
// ./src/main.js